var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "draggable",
    {
      attrs: {
        options: {
          animation: 300,
          handle: ".page-dragged"
        },
        list: _vm.menus,
        move: _vm.moveElement,
        group: "pagesList",
        tag: "ul"
      },
      on: { end: _vm.handleEndDrag }
    },
    _vm._l(_vm.menus, function(menu, index) {
      return _c(
        "li",
        {
          key: menu.id,
          attrs: {
            parent: menu.id,
            "parent-loc": index,
            "data-parent": menu.parent_id
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "page",
              class: [
                {
                  "page-child": menu.parent_id !== 0,
                  active: _vm.pageSelected && _vm.pageSelected.id === menu.id
                },
                _vm.isParent
                  ? index === 0 && _vm.menus.length > 1
                    ? _vm.menus[1].type === "menu" && menu.type === "visible"
                      ? ""
                      : "page-dragged"
                    : "page-dragged"
                  : "page-dragged"
              ],
              attrs: {
                id: menu.id + "-" + menu.name.toLowerCase().replaceAll(" ", "-")
              },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  _vm.selectPage(menu)
                }
              }
            },
            [
              _c("div", { staticClass: "d-flex align-items-start" }, [
                _c("img", {
                  staticClass: "page-icon",
                  attrs: {
                    src:
                      _vm.pageSelected && _vm.pageSelected.id === menu.id
                        ? menu.icon_active
                        : menu.icon_white
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "page-name" }, [
                  _vm._v(_vm._s(menu.name))
                ])
              ]),
              _vm._v(" "),
              menu.child && menu.type === "menu"
                ? _c("i", { staticClass: "fa fa-chevron-down dropdown-icon" })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "page-config",
                  attrs: { id: "editPage-" + menu.id },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      _vm.openEditPage(menu)
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/app-manager/icon/edit-page.svg")
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "b-popover",
                {
                  ref: "editPage-" + menu.id,
                  refInFor: true,
                  attrs: {
                    target: "editPage-" + menu.id,
                    triggers: "manual",
                    placement: "bottom",
                    container: "sidebar-web"
                  }
                },
                [
                  _c("h3", [_vm._v("Edit Menu")]),
                  _vm._v(" "),
                  _c("j-form-page", {
                    ref: "formEditPage-" + menu.id,
                    refInFor: true,
                    attrs: {
                      "is-popover": true,
                      mode: "edit",
                      "data-page": _vm.dataPageForEdit,
                      "icon-options": _vm.iconOptions
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-content-end mt-3" },
                    [
                      _c("div", { staticClass: "page-trash" }, [
                        _c("i", {
                          staticClass: "fa fa-trash fa-lg",
                          on: {
                            click: function($event) {
                              _vm.$emit("delete-page", {
                                id: menu.id,
                                name: menu.name
                              })
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "button-border mr-2",
                          on: { click: _vm.closeEditPage }
                        },
                        [_vm._v("\n            Close\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "button-blue",
                          on: { click: _vm.editPage }
                        },
                        [_vm._v("\n            Apply\n          ")]
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          menu.child && menu.type === "menu"
            ? _c("sidebar-menu", {
                ref: "sidebarChildMenu",
                refInFor: true,
                attrs: {
                  menus: menu.child,
                  "is-parent": false,
                  "page-selected": _vm.pageSelected,
                  "icon-options": _vm.iconOptions,
                  "list-pages": _vm.listPages
                },
                on: {
                  "selected-page": _vm.changeSelectedPage,
                  "close-create-page": function($event) {
                    _vm.$emit("close-create-page")
                  },
                  "save-page": function($event) {
                    _vm.$emit("save-page")
                  },
                  "update-page": _vm.updatePage,
                  "delete-page": function($event) {
                    _vm.$emit("delete-page")
                  },
                  "reload-pages": function($event) {
                    _vm.$emit("reload-pages")
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          menu.child && menu.type === "menu"
            ? _c(
                "div",
                {
                  staticClass: "add-page add-sub-page",
                  attrs: { id: "createSubPage-" + menu.id },
                  on: {
                    click: function($event) {
                      _vm.openCreateSubPage(menu.id)
                    }
                  }
                },
                [
                  _c("span", [_vm._v("+")]),
                  _vm._v("\n      Add Sub Menu\n    ")
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-popover",
            {
              ref: "createSubPage-" + menu.id,
              refInFor: true,
              attrs: {
                target: "createSubPage-" + menu.id,
                triggers: "manual",
                placement: "bottom",
                container: "sidebar-web"
              }
            },
            [
              _c("h3", [_vm._v("Add Sub Menu")]),
              _vm._v(" "),
              _c("j-form-page", {
                ref: "formSubPage-" + menu.id,
                refInFor: true,
                attrs: {
                  "is-popover": true,
                  mode: "createSub",
                  "icon-options": _vm.iconOptions
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex justify-content-end mt-3" }, [
                _c(
                  "button",
                  {
                    staticClass: "button-border mr-2",
                    on: { click: _vm.closeCreateSubPage }
                  },
                  [_vm._v("\n          Close\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "button-blue",
                    on: { click: _vm.createSubPage }
                  },
                  [_vm._v("\n          Save\n        ")]
                )
              ])
            ],
            1
          )
        ],
        1
      )
    })
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-342e0c04", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-342e0c04","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/application-manager/detail/app-tabs/partials/sidebarMenu.vue
// module id = null
// module chunks = 